import React, {useState} from "react";
import {Button, Table} from "antd";
import moment from "moment";
import {Link} from "react-router-dom/cjs/react-router-dom.min";
import TransferCenterConfirmModal from "../transferCenterConfirmModal/TransferCenterConfirmModal";

const TransferCenterListTable = ({
    transferCenterList,
    loading,
    refetchTransferCenterList,
    setPage
}) => {
    const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
    const [actionType, setActionType] = useState(null);
    const [transferCenterId, setTransferCenterId] = useState();

    const columns = [
        {
            title: "Gün",
            dataIndex: "createdAt",
            key: "createdAt",
            render: createdAt => {
                return <span>{moment(createdAt).format("DD.MM.YYYY")}</span>;
            }
        },
        {
            title: "Firma Adı",
            dataIndex: "supplierIds",
            key: "supplierIds",
            render: supplierIds => {
                return <span>{supplierIds ? supplierIds[0].name : "-"}</span>;
            }
        },
        {
            title: "Transfer Merkezi",
            dataIndex: "subCompany",
            key: "subCompany",
            render: subCompany => {
                return (
                    <Link to={`/companies/sub-company/${subCompany._id}`}>{subCompany.name}</Link>
                );
            }
        },
        {
            title: "Şehir",
            dataIndex: "city",
            key: "city"
        },
        {
            title: "İlçe",
            dataIndex: "district",
            key: "district"
        },
        {
            title: "Onay Durumu",
            dataIndex: "status",
            key: "status",
            render: status => {
                return (
                    <span>
                        {status === "pending"
                            ? "Onay Bekliyor"
                            : status === "active"
                            ? "Onaylandı"
                            : status === "rejected"
                            ? "Reddedildi"
                            : "-"}
                    </span>
                );
            }
        },
        {
            title: "Aksiyon",
            dataIndex: "action",
            key: "action",
            render: (text, record) =>
                record.status === "pending" ? (
                    <div style={{display: "flex", gap: 8}}>
                        <Button type="primary" onClick={() => handleActiveTransferCenter(record)}>
                            Onayla
                        </Button>
                        <Button type="danger" onClick={() => handleRejectTransferCenter(record)}>
                            Reddet
                        </Button>
                    </div>
                ) : record.status === "active" ? (
                    <div>Onaylandı</div>
                ) : record.status === "rejected" ? (
                    <div>Reddedildi</div>
                ) : (
                    "-"
                )
        }
    ];

    const handleActiveTransferCenter = record => {
        setIsOpenConfirmModal(true);
        setActionType("active");
        setTransferCenterId(record._id);
    };

    const handleRejectTransferCenter = record => {
        setIsOpenConfirmModal(true);
        setActionType("rejected");
        setTransferCenterId(record._id);
    };

    const handleTableChange = pagination => {
        setPage(pagination.current);
    };

    return (
        <>
            <Table
                dataSource={transferCenterList.data || []}
                loading={loading}
                columns={columns}
                scroll={{x: 1000}}
                pagination={{
                    total: transferCenterList?.pagination?.total,
                    pageSize: transferCenterList?.pagination?.limit,
                    current: transferCenterList?.pagination?.page,
                    onChange: page => {
                        handleTableChange({current: page});
                    }
                }}
            />
            <TransferCenterConfirmModal
                isOpenConfirmModal={isOpenConfirmModal}
                onCloseConfirmModal={() => setIsOpenConfirmModal(false)}
                actionType={actionType}
                transferCenterId={transferCenterId}
                refetchTransferCenterList={refetchTransferCenterList}
            />
        </>
    );
};

export default TransferCenterListTable;
